import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import { trackEvent } from "utils/tracking";

import BannerWrapper from "../BannerWrapper";

interface Props {
  pastDuePlan: string;
}

const PastDueBanner = ({ pastDuePlan }: Props) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <BannerWrapper
      color={"#C92D0A"}
      onClick={() => {
        trackEvent("Past Due Banner Clicked");
        navigate(`/${routes.settings}`);
      }}
    >
      <Grid container alignItems={"center"} justifyContent={"center"}>
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          <Box component="i" className="fa-regular fa-warning" sx={{ mr: 1 }} />

          {isMobileScreen ? (
            "We could not process your latest payment"
          ) : (
            <>
              {" "}
              Action required: we could not process your latest payment for{" "}
              <strong>{pastDuePlan}</strong> plan. Please update to restore
              access.
            </>
          )}
        </Typography>

        <IconButton sx={{ fontSize: 14 }}>
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ color: "white" }}
          />
        </IconButton>
      </Grid>
    </BannerWrapper>
  );
};

export default PastDueBanner;
